import {
  type ComponentType
} from 'react';
import {
  AmsSocketProvider
} from './ams-socket-provider.component';

export const withAmsSocket = <P extends object>(WrappedComponent: ComponentType<P>) =>
  (props: P) => {
    return (
      <AmsSocketProvider>
        <WrappedComponent {...props} />
      </AmsSocketProvider>
    );
  };
